import { TailSpin as LoadingSpinner } from "react-loader-spinner";

interface LoaderProps {
    width?: number;
    height?: number;
    color?: string;
}

export function Loader({
    width = 64,
    height = 64,
    color = "var(--color-primary)"
}: LoaderProps): JSX.Element {
    return (
        <LoadingSpinner
            width={width}
            height={height}
            ariaLabel="tail-spin-loading"
            wrapperStyle={{
                display: "flex",
                justifyContent: "center"
            }}
            color={color}
        />
    );
}
